import * as React from "react"

export const TabsContext = React.createContext<any>(null)
